import { MATERIAL_TYPES } from '@mixtiles/web-backend-shared'

export function getDiscountMaterialType(metadata) {
  return metadata?.materialType || MATERIAL_TYPES.CLASSIC
}
